import { PagedListRequestInterface, PagedResponseInterface, PaginatedAPIInterface } from '@vendasta/galaxy/table';
import { combineLatest, Observable } from 'rxjs';
import { AttributeInterface, EmailEventService, SenderType } from '@vendasta/email';
import { map, switchMap } from 'rxjs/operators';
import { ListLinkClickActivityForAttributeResponse } from '@vendasta/email/lib/_internal';

export interface ClickActivity {
  email: string;
  dateClicked: Date;
  clicks: number;
}

interface ContactLinkClickStatsRequest extends PagedListRequestInterface {
  attribute: AttributeInterface;
  normalizedURL: string;
}

interface ParameterServiceInterface {
  attribute: AttributeInterface;
  senderId$: Observable<string>;
  eventUrl$: Observable<string>;
}

export class ParameterService implements ParameterServiceInterface {
  readonly attribute: AttributeInterface;
  readonly senderId$: Observable<string>;
  readonly eventUrl$: Observable<string>;

  constructor(attribute: AttributeInterface, senderID$: Observable<string>, eventUrl$: Observable<string>) {
    this.attribute = attribute;
    this.senderId$ = senderID$;
    this.eventUrl$ = eventUrl$;
  }
}

export class ContactTableDataService implements PaginatedAPIInterface<ClickActivity> {
  constructor(private parameterService: ParameterServiceInterface, private emailEventService: EmailEventService) {}

  get(r: ContactLinkClickStatsRequest): Observable<PagedResponseInterface<ClickActivity>> {
    return combineLatest([this.parameterService.senderId$, this.parameterService.eventUrl$]).pipe(
      switchMap(([senderId, eventUrl]: [string, string]) => {
        const senderType = senderId.startsWith('AG') ? SenderType.SENDER_TYPE_BUSINESS : SenderType.SENDER_TYPE_PARTNER;
        return this.emailEventService.listLinkClickActivityForAttribute(
          {
            type: senderType,
            id: senderId,
          },
          {
            key: this.parameterService.attribute.key,
            value: this.parameterService.attribute.value,
          },
          eventUrl,
          r.pagingOptions.cursor,
          r.pagingOptions.pageSize,
        );
      }),
      map((resp: ListLinkClickActivityForAttributeResponse) => {
        return {
          data:
            resp?.data?.map((m) => {
              return {
                email: m.recipient?.emailAddress,
                clicks: m.count,
                dateClicked: m.recentDate,
              };
            }) || ([] as ClickActivity[]),
          pagingMetadata: resp?.pagingMetadata || {},
        } as PagedResponseInterface<ClickActivity>;
      }),
    );
  }
}
